import * as yup from 'yup';
import * as regex from '../../../utils/constants/regex';

export const userFormSchema = yup.object({
  name: yup.string().required('Name is required'),
  email: yup
    .string()
    .transform((value) =>
      value === '' ? undefined : value
    )
    .matches(regex.EMAIL, 'Please enter a valid email'),
  mobile: yup
    .string()
    .required('Mobile Number is required')
    .length(10, 'Please enter valid number')
    .matches(
      regex.MOBILE_NUMBER,
      'Please enter valid number'
    ),
  country: yup.string().required('Country is required'),
  company: yup.array().required('Company is required'),
  plant: yup.array(),
  ugdn: yup.string(),
  roleArray: yup.array().required('User role is required'),
});

export type TUserFormData = yup.InferType<
  typeof userFormSchema
>;
